module.exports = __webpack_public_path__ + "assets/alerts_getting_notified.png";